export const SupportDetailDocs = () => {
    console.log('SupportDetailDocs');

    return (
        <>
            <img src={'https://classedu.test.class.com/support_docs.png'} style={{ width: 'calc(100% - 40px)', left: '20px' }} />
        </>
    );
};
